export default __webpack_public_path__ + "static/media/proj15.52176a21.png";